module.exports = __webpack_public_path__ + "static/media/karveli-psomi.81f7c7d2.jpg";